import React, { useEffect, useState, useRef } from "react";
import {
  Box, Grid, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Divider, Dialog, DialogContent, DialogActions,
  Button, TextField, MenuItem
} from "@mui/material";
import axios from "axios";
import io from "socket.io-client";
import SearchBar from "../../../../Common/UtilityCommon/SearchBar";
import { formatReadableAmount } from "../../../../Common/FormatFunctions/FormatAmount";
import AccountMasterHelp from "../../../../Helper/AccountMasterHelp";

const headerCellStyle = {
  fontWeight: "bold",
  backgroundColor: "#3f51b5",
  color: "white",
  padding: "8px",
  textAlign: "center",
};

const LiveTenders = () => {
  const apikey = process.env.REACT_APP_API;
  const socketURL = process.env.REACT_APP_API_URL;
  const company_code = sessionStorage.getItem("Company_Code");
  const year_code = sessionStorage.getItem("Year_Code");

  const [tenders, setTenders] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [netAmount, setNetAmount] = useState("0.00");


  const formatDateForInput = (dateString) => {
  if (!dateString) return new Date().toISOString().split("T")[0];
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};

  const [formData, setFormData] = useState({
    Tender_No: "",
    Buyer: "",
    ShipTo: "",
    Buyer_Party: "",
    sub_broker: "",
    buyerid: "",
    buyerpartyid: "",
    sbr: "",
    shiptoid: "",
    Buyer_Quantal: "",
    Sale_Rate: "",
    Commission_Rate: "",
    gst_rate: 5.0,
    tcs_rate: 0.1,
    gst_amt: 0.0,
    tcs_amt: 0.0,
    Delivery_Type: "C",
    Sauda_Date: new Date().toISOString().split("T")[0],
    Lifting_Date: new Date().toISOString().split("T")[0],
    Narration: "",
    Sauda_Time: new Date().toLocaleTimeString("en-GB", { hour12: false }),
    EbuySelectedParty: "",
    EbuySelectedAccoid: "",
    EbuySugarLiftingDate: "",
    Payment_To: "",
    pt: "",
  });

  const [millCode, setMillCode] = useState("");
  const [millName, setMillName] = useState("");
  const [buyerName, setBuyerName] = useState("");
  const [shipToName, setShipToName] = useState("");
  const [brokerName, setBrokerName] = useState("");
  const [subBrokerName, setSubBrokerName] = useState("");
  const [tenderdetailid, settenderDetailId] = useState(0)
  const [tenderNo, setTenderNo] = useState(0)
  const buyerRef = useRef();
  const [selectedPartyName, setSelectedPartyName] = useState("");

  const fetchTenders = async () => {
    try {
      const res = await axios.get(
        `${apikey}/get_live_tenders?Company_Code=${company_code}&Year_Code=${year_code}`
      );
      if (res.data.all_data) {
        setTenders(res.data.all_data);
        setFiltered(res.data.all_data);
      }
    } catch (err) {
      console.error("Error fetching tenders:", err);
    }
  };

  useEffect(() => {
    const socket = io(`${socketURL}`, { transports: ["websocket"] });
    socket.on("tender_added", fetchTenders);
    socket.on("tender_updated", fetchTenders);
    socket.on("tender_deleted", fetchTenders);
    fetchTenders();
    return () => socket.disconnect();
  }, []);

  useEffect(() => {
    const search = searchTerm.toLowerCase();
    setFiltered(
      tenders.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(search)
        )
      )
    );
  }, [searchTerm, tenders]);

  const handleSearchTermChange = (e) => setSearchTerm(e.target.value);

  const groupBySaudaDate = (data) => {
    const grouped = {};
    data.forEach((item) => {
      if (!grouped[item.Sauda_Date]) grouped[item.Sauda_Date] = [];
      grouped[item.Sauda_Date].push(item);
    });
    return grouped;
  };

  // const calculateRowProfit = (i) => {
  //   const pRate = i.Purc_Rate === 0 ? parseFloat(i.Mill_Rate || 0) : parseFloat(i.Purc_Rate || 0);
  //   const sRate = parseFloat(i.Sale_Rate || 0);
  //   const qty = parseFloat(i.Qntl || 0);
  //   return (sRate - pRate) * qty;
  // };

  const calculateRowProfit = (row) => {
    const purcRate = parseFloat(row?.Purc_Rate) || 0;
    const millRate = parseFloat(row?.Mill_Rate) || 0;
    const saleRate = parseFloat(row?.Sale_Rate) || 0;
    const quantity = parseFloat(row?.Qntl) || 0;


    const effectivePurchaseRate = purcRate > 0 ? purcRate : millRate;


    const profit = (saleRate - effectivePurchaseRate) * quantity;


    return isNaN(profit) ? 0 : parseFloat(profit.toFixed(2));
  };



  const calculateTotalProfit = (group) => group.reduce((t, i) => t + calculateRowProfit(i), 0);
  const calculateTotalQuantity = (group) => group.reduce((t, i) => t + parseFloat(i.Qntl || 0), 0);

  const handleEditClick = (item) => {

    const formattedLiftingDate = formatDateForInput(item.Lifting_Date);

    setFormData({
      ...formData,
      Tender_No: item.Tender_No,
      Buyer_Quantal: item.Qntl,
      Sale_Rate: item.Sale_Rate,
      Commission_Rate: item.Commission_Rate,
      Sauda_Date: item.Sauda_Date,
      Lifting_Date: formattedLiftingDate,
      Buyer: item.Buyer,
      buyerid: item.buyerid,
      buyerpartyid: item.buyerpartyid,
      sub_broker: item.sub_broker,
      sbr: item.sbr,
      Buyer_Party: item.Buyer_Party,
      ShipTo: item.ShipTo,
      shiptoid: item.shiptoid,
      EbuySelectedParty: item.EbuySelectedParty,
      EbuySelectedAccoid: item.EbuySelectedAccoid ,
      EbuySugarLiftingDate: formattedLiftingDate,
      Payment_To: item.Buyer,
      pt: item.buyerid
    });
    setBuyerName(item.buyerName);
    settenderDetailId(item.tenderdetailid)
    setTenderNo(item.Tender_No)
    setBrokerName(item.brokername)
    setShipToName(item.shipToName);
    setSubBrokerName(item.subBrokerName)
    setMillName(item.Mill);
    setSelectedPartyName(item.selectedPartyName || "");
    setOpenEdit(true);
  };

  const handleAccountSelect =
    (field, idField) => (code, accoid, selectedName) => {
      setFormData((prev) => {
        const updatedData = { 
            ...prev, 
            [field]: code, 
            [idField]: accoid 
        };

        if (field === "Buyer") {
            updatedData.Payment_To = code;  
            updatedData.pt = accoid;      
        }

        return updatedData;
    });
      if (field === "Buyer") setBuyerName(selectedName);
      if (field === "ShipTo") setShipToName(selectedName);
      if (field === "Buyer_Party") setBrokerName(selectedName);
      if (field === "sub_broker") setSubBrokerName(selectedName);
      if (field === "EbuySelectedParty") setSelectedPartyName(selectedName);
    };

  const handleMillCode = (code, accoid, name) => {
    setMillCode(code);
    setMillName(name);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // GST / TCS / Net Amount Calculation
  useEffect(() => {
    const qty = parseFloat(formData.Buyer_Quantal || 0);
    const rate = parseFloat(formData.Sale_Rate || 0);
    const gstRate = parseFloat(formData.gst_rate || 0);
    const tcsRate = parseFloat(formData.tcs_rate || 0);

    const taxable = qty * rate;
    const gst_amt = (taxable * gstRate) / 100;
    const tcs_amt = ((taxable + gst_amt) * tcsRate) / 100;
    const net = taxable + gst_amt + tcs_amt;

    setFormData((prev) => ({
      ...prev,
      gst_amt: gst_amt.toFixed(2),
      tcs_amt: tcs_amt.toFixed(2),
    }));
    setNetAmount(net.toFixed(2));
  }, [formData.Buyer_Quantal, formData.Sale_Rate, formData.gst_rate, formData.tcs_rate]);

  const handleSaveEdit = async () => {
    try {
      await axios.put(`${apikey}/update_tender_detail`, {
        detailData: {
          ...formData, Company_Code: company_code, Year_Code: year_code, tenderdetailid: tenderdetailid,
          Tender_No: tenderNo
        },
      });
      setOpenEdit(false);
      fetchTenders();
      alert("Tender updated successfully!");
      setTenderNo(0)
      settenderDetailId(0)
    } catch (err) {
      console.error(err);
      alert("Error updating tender!");
    }
  };

  return (
    <Box sx={{ mt: -10, mb: 20 }}>
      <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
        <Grid item xs={12} sm={6} ml={30}>
          <SearchBar value={searchTerm} onChange={handleSearchTermChange} />
        </Grid>
      </Grid>

      <Paper elevation={3} sx={{ overflow: "auto", maxHeight: "90vh" }}>
        <TableContainer>
          <div style={{ maxHeight: "750px", overflow: "auto" }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={headerCellStyle}>Action</TableCell>
                  <TableCell sx={headerCellStyle}>Sauda Date</TableCell>
                  <TableCell sx={headerCellStyle}>Sauda Time</TableCell>
                  <TableCell sx={headerCellStyle}>Mill Name</TableCell>
                  <TableCell sx={headerCellStyle}>Buyer Name</TableCell>
                  <TableCell sx={headerCellStyle}>DO Name</TableCell>
                  <TableCell sx={headerCellStyle}>Quantity</TableCell>
                  <TableCell sx={headerCellStyle}>Grade</TableCell>
                  <TableCell sx={headerCellStyle}>Season</TableCell>
                  <TableCell sx={headerCellStyle}>Mill Rate</TableCell>
                  <TableCell sx={headerCellStyle}>Purchase Rate</TableCell>
                  <TableCell sx={headerCellStyle}>Sale Rate</TableCell>
                  <TableCell sx={headerCellStyle}>Profit & Loss</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filtered.length > 0 ? (
                  Object.entries(groupBySaudaDate(filtered)).map(([date, group], groupIndex) => (
                    <React.Fragment key={date}>
                      {group.map((item, index) => (
                        <TableRow key={`${groupIndex}-${index}`} hover>
                          <TableCell align="center">
                            <Button
                              variant="outlined"
                              size="small"
                              color="primary"
                              onClick={() => handleEditClick(item)}
                            >
                              Edit
                            </Button>
                          </TableCell>
                          <TableCell>{item.Sauda_Date}</TableCell>
                          <TableCell style={{ whiteSpace: "nowrap" }}>{item.Sauda_Time}</TableCell>
                          <TableCell>{item.Mill}</TableCell>
                          <TableCell>{item.buyerName}</TableCell>
                          <TableCell>{item.DO}</TableCell>
                          <TableCell align="right">{item.Qntl}</TableCell>
                          <TableCell>{item.Grade}</TableCell>
                          <TableCell>{item.season}</TableCell>
                          <TableCell align="right">{item.Mill_Rate}</TableCell>
                          <TableCell align="right">
                            {item.Purc_Rate === 0 ? item.Mill_Rate : item.Purc_Rate}
                          </TableCell>
                          <TableCell align="right">{item.Sale_Rate}</TableCell>
                          <TableCell
                            align="right"
                            style={{
                              color: calculateRowProfit(item) >= 0 ? "green" : "red",
                              fontWeight: "bold",
                            }}
                          >
                            {formatReadableAmount(calculateRowProfit(item).toFixed(2))}
                          </TableCell>
                        </TableRow>
                      ))}

                      <TableRow sx={{ backgroundColor: "#edf0df" }}>
                        <TableCell colSpan={6} align="right">
                          <strong>Total for {date}:</strong>
                        </TableCell>
                        <TableCell align="right">
                          <strong>
                            {formatReadableAmount(calculateTotalQuantity(group).toFixed(2))}
                          </strong>
                        </TableCell>
                        <TableCell colSpan={4}></TableCell>
                        <TableCell align="right" style={{ whiteSpace: "nowrap" }}>
                          <strong>Expected Profit & Loss:</strong>
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{
                            color: calculateTotalProfit(group) >= 0 ? "green" : "red",
                            fontWeight: "bold",
                          }}
                        >
                          <strong>
                            {formatReadableAmount(calculateTotalProfit(group).toFixed(2))}
                          </strong>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell colSpan={12} sx={{ height: "10px", borderBottom: "none" }} />
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={12} sx={{ padding: 0, border: 0 }}>
                          <Divider sx={{ borderBottomWidth: 2, backgroundColor: "#3f51b5" }} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={12} sx={{ height: "10px", borderBottom: "none" }} />
                      </TableRow>
                    </React.Fragment>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={12} align="center">
                      Data Not Found!
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </TableContainer>
      </Paper>

      {/* Edit Tender Modal */}
      <Dialog
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        fullWidth
        maxWidth="md"
        TransitionProps={{ timeout: 0 }}
        transitionDuration={0}
        keepMounted
      >
        <Box sx={{
          backgroundColor: "#3f51b5",
          color: "white",
          textAlign: "center",
          py: 1.2,
          fontWeight: 600,
        }}>
          Edit Live Tender
        </Box>
        <DialogContent sx={{ mt: 1 }}>
          <Grid container spacing={1}>
            {/* <Grid item xs={12} sm={4}><Typography fontWeight="bold">Mill:</Typography></Grid> */}
            {/* <Grid item xs={12} sm={8}>
              <AccountMasterHelp name="Mill_Code" CategoryCode={millCode} CategoryName={millName} onAcCodeClick={handleMillCode} />
            </Grid> */}

            <Grid item xs={12} sm={4}><Typography fontWeight="bold">Buyer:</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <AccountMasterHelp name="Buyer" CategoryCode={formData.Buyer} CategoryName={buyerName} onAcCodeClick={handleAccountSelect("Buyer", "buyerid")} />
            </Grid>

            <Grid item xs={12} sm={4}><Typography fontWeight="bold">Ship To:</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <AccountMasterHelp name="ShipTo" CategoryCode={formData.ShipTo} CategoryName={shipToName} onAcCodeClick={handleAccountSelect("ShipTo", "shiptoid")} />
            </Grid>

            <Grid item xs={12} sm={4}><Typography fontWeight="bold">Broker:</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <AccountMasterHelp
                name="Buyer_Party"
                CategoryCode={formData.Buyer_Party}
                CategoryName={brokerName}
                onAcCodeClick={handleAccountSelect("Buyer_Party", "buyerpartyid")}
              />
            </Grid>

            <Grid item xs={12} sm={4}><Typography fontWeight="bold">Sub Broker:</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <AccountMasterHelp
                name="sub_broker"
                CategoryCode={formData.sub_broker}
                CategoryName={subBrokerName}
                onAcCodeClick={handleAccountSelect("sub_broker", "sbr")}
              />
            </Grid>


            {/* <Grid item xs={12} sm={4}>
              <Typography fontWeight="bold">Select Party:</Typography>
            </Grid>
            <Grid item xs={12} sm={8}>
              <AccountMasterHelp
                name="EbuySelectedParty"
                CategoryCode={formData.EbuySelectedParty}
                CategoryName={selectedPartyName}
                onAcCodeClick={handleAccountSelect("EbuySelectedParty", "EbuySelectedAccoid")}
              />
            </Grid>

        
            <Grid item xs={12} sm={4}><Typography fontWeight="bold">Lifting Date:</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth name="Lifting_Date" type="date" value={formData.Lifting_Date} onChange={handleInputChange} />
            </Grid> */}


            <Grid item xs={12} sm={4}><Typography fontWeight="bold">Buyer Quantal:</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth name="Buyer_Quantal" type="number" value={formData.Buyer_Quantal} onChange={handleInputChange} />
            </Grid>

            <Grid item xs={12} sm={4}><Typography fontWeight="bold">Sale Rate:</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth name="Sale_Rate" type="number" value={formData.Sale_Rate} onChange={handleInputChange} />
            </Grid>

            <Grid item xs={12} sm={4}><Typography fontWeight="bold">GST Rate:</Typography></Grid>
            <Grid item xs={12} sm={4}>
              <TextField size="small" fullWidth name="gst_rate" type="number" value={formData.gst_rate} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField size="small" fullWidth label="GST Amount" value={formData.gst_amt} InputProps={{ readOnly: true }} />
            </Grid>

            <Grid item xs={12} sm={4}><Typography fontWeight="bold">TCS Rate:</Typography></Grid>
            <Grid item xs={12} sm={4}>
              <TextField size="small" fullWidth name="tcs_rate" type="number" value={formData.tcs_rate} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField size="small" fullWidth label="TCS Amount" value={formData.tcs_amt} InputProps={{ readOnly: true }} />
            </Grid>

            <Grid item xs={12} sm={4}><Typography fontWeight="bold">Net Amount:</Typography></Grid>
            <Grid item xs={12} sm={8}>
              <TextField size="small" fullWidth value={netAmount} InputProps={{ readOnly: true, sx: { fontWeight: "bold", fontSize: "1rem" } }} />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", mb: 1 }}>
          <Button variant="outlined" color="secondary" onClick={() => setOpenEdit(false)} sx={{ width: 120 }}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleSaveEdit} sx={{ width: 120 }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LiveTenders;